var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.78 72.91L11.01 50.67L30.32 39.41L68.99 61.74L49.78 72.91Z",
    fill: "url(#paint0_linear_1352_358800)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.99 29.48L30.3 7.08997L11.01 18.24L49.69 40.62L68.99 29.48Z",
    fill: "url(#paint1_linear_1352_358800)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.69 40.62L11.01 18.14L11.04 40.43L49.72 62.91L49.69 40.62Z",
    fill: "url(#paint2_linear_1352_358800)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9901 29.48V51.78L49.7201 62.91L49.6901 40.62L68.9901 29.48Z",
    fill: "url(#paint3_linear_1352_358800)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.87 56.32L39.26 54.23V37.22L42.87 39.31V56.32Z",
    fill: "url(#paint4_linear_1352_358800)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.46 50.2999L28.85 48.2099V31.2L32.46 33.29V50.2999Z",
    fill: "url(#paint5_linear_1352_358800)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0501 44.2799L18.4301 42.1899V25.1799L22.0501 27.2699V44.2799Z",
    fill: "url(#paint6_linear_1352_358800)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1352_358800",
    x1: 20.64,
    y1: 67.36,
    x2: 59.34,
    y2: 45.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1352_358800",
    x1: 11.01,
    y1: 23.86,
    x2: 68.99,
    y2: 23.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1352_358800",
    x1: 11.01,
    y1: 40.52,
    x2: 49.72,
    y2: 40.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1352_358800",
    x1: 49.6901,
    y1: 46.19,
    x2: 68.9901,
    y2: 46.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1352_358800",
    x1: 39.26,
    y1: 46.77,
    x2: 42.87,
    y2: 46.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1352_358800",
    x1: 28.85,
    y1: 40.75,
    x2: 32.46,
    y2: 40.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1352_358800",
    x1: 18.4301,
    y1: 34.7299,
    x2: 22.0501,
    y2: 34.7299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoService);
export default __webpack_public_path__ + "static/media/no_service.cc30abf264aba6a0ebd9cb9bdfe7d90f.svg";
export { ForwardRef as ReactComponent };